<ion-row class="top-header {{pageHeaderClass}}">
  <ion-col class="heading-wrap ion-no-padding" size="11">
    <!-- Voucher Notification Animation -->
    <div>
      <ng-lottie *ngIf="voucherStatus()" (click)="openLeftMenu(); closeNotification();" class="voucher-notification"
      [options]="options">
     </ng-lottie>
      @if (menuStatus) {
        <ng-lottie
          class="menu-animation"
          [options]="menuOptions"
          (click)="openLeftMenu(); closeNotification(); onClick('menu_icon');"
          (animationCreated)="updateAnimationStatus('menu_icon', menuDuration);"
        ></ng-lottie>
      }
    </div>
    <img src="../../../assets/icon/menu_active.svg" class="menu-image" (click)="openLeftMenu()" />
    <h3 class="page-heading">
      {{pageHeading}}
    </h3>
  </ion-col>
  <ion-col class="notification-wrap ion-no-padding" size="1">
    <app-notification class="header-notify" [inboxStatus]="inboxStatus()" [inboxDuration]="inboxDuration" [inboxOptions]="inboxOptions"></app-notification>
  </ion-col>
</ion-row>
